//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Construction from 'src/store/models/Construction';
export default {
  data: function data() {
    return {
      web_code: null
    };
  },
  methods: {
    openConstruction: function openConstruction() {
      var _this = this;
      if (this.web_code) {
        Construction.$getByCode(this.web_code.toUpperCase()).then(function (response) {
          _this.$router.push("/cantiere/".concat(_this.web_code.toUpperCase()));
          _this.web_code = null;
        }).catch(function () {
          _this.$q.notify({
            type: 'warning',
            icon: 'warning',
            position: 'top',
            message: _this.$t('Cantiere non trovato!')
          });
        });
      }
    }
  }
};